import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import styles from "./barList.module.css";
import { EASE } from "../../UTILS/ANIMATION/motionVariants";

// Single-series horizontal bar list, rendered as a real table so the numbers
// are available to assistive tech. rows: [{ label, value }] (value in %).
const BarList = ({ title, rows, note }) => {
  const reduce = useReducedMotion();
  const max = Math.max(...rows.map((r) => r.value));
  return (
    <figure className={styles.figure}>
      <table className={styles.table}>
        <caption className={styles.caption}>{title}</caption>
        <thead className={styles.srOnly}>
          <tr>
            <th scope="col">Group</th>
            <th scope="col">Share of patients</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r, i) => (
            <tr key={r.label} className={styles.row} title={`${r.label}: ${r.value}%`}>
              <th scope="row" className={styles.label}>
                {r.label}
              </th>
              <td className={styles.cell}>
                <span className={styles.track}>
                  <motion.span
                    className={styles.bar}
                    style={{ width: `${(r.value / max) * 100}%` }}
                    initial={reduce ? false : { scaleX: 0 }}
                    whileInView={{ scaleX: 1 }}
                    viewport={{ once: true, amount: 0.6 }}
                    transition={{ duration: 0.9, delay: i * 0.06, ease: EASE }}
                  />
                </span>
                <span className={styles.value}>{r.value}%</span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {note && <figcaption className={styles.note}>{note}</figcaption>}
    </figure>
  );
};

export default BarList;
